import Atu2CohortPanel from '../components/atu2/Atu2CohortPanel';
import Atu2Glossary from '../components/atu2/Atu2Glossary';
import Atu2NextActionPanel from '../components/atu2/Atu2NextActionPanel';
import Atu2ReadinessDetails from '../components/atu2/Atu2ReadinessDetails';
import Atu2RehearsalPanel from '../components/atu2/Atu2RehearsalPanel';
import Atu2SafetySummary from '../components/atu2/Atu2SafetySummary';
import Atu2OpsAutomationPanel from '../components/atu2/Atu2OpsAutomationPanel';
import DailyTacticalReportVisibility from '../components/atu2/DailyTacticalReportVisibility';
import Atu2ViewSwitch from '../components/atu2/Atu2ViewSwitch';
import useAtu2LabData from '../hooks/useAtu2LabData';
import './Atu2Lab.css';

export default function Atu2Lab() {
  const data = useAtu2LabData();
  const {
    readiness, market, weeklyAudit, opsReport, weeklyReview, blockerAlert, reportHistory, proposals,
    weeklyAuditError, opsError, historyError, proposalsError, loading, error, refreshedAt, load,
  } = data;

  if (loading && (!readiness || !market)) return <PageState text="2.0 검증 상태 로딩 중..." />;
  if (error && (!readiness || !market)) return <PageState text={`API 오류: ${error}`} error onRetry={load} />;
  if (!readiness || !market) return null;

  return (
    <div className="atu2-lab-page">
      <header className="atu2-lab-header">
        <div>
          <span className="atu2-kicker">ATU2 2.0</span>
          <h1>2.0 기술 상세</h1>
          <p>운영 판단에 사용된 원본 상태값, 기록 묶음과 기술 식별자를 확인합니다.</p>
        </div>
        <button className="atu2-refresh" onClick={load} disabled={loading}>
          {loading ? '갱신 중...' : '새로고침'}
        </button>
      </header>
      <Atu2ViewSwitch current="technical" />
      {error && <div className="atu2-state error">최신 조회 실패: {error} (이전 데이터 표시 중)</div>}
      <section className="atu2-hero-lock">
        <div>
          <strong>실전 매매 잠금 유지</strong>
          <p>이 화면은 읽기 전용입니다. 주문 버튼을 만들지 않고, 공식 시작 전 상태만 보여줍니다.</p>
        </div>
        <span>{refreshedAt ? `${refreshedAt.toLocaleTimeString('ko-KR')} 갱신` : '갱신 대기'}</span>
      </section>
      <Atu2SafetySummary readiness={readiness} market={market} />
      <Atu2RehearsalPanel
        readiness={readiness}
        market={market}
        audit={weeklyAudit}
        auditError={weeklyAuditError}
      />
      <Atu2OpsAutomationPanel
        opsReport={opsReport}
        weeklyReview={weeklyReview}
        blockerAlert={blockerAlert}
        error={opsError}
      />
      <DailyTacticalReportVisibility
        history={reportHistory}
        proposals={proposals}
        historyError={historyError}
        proposalsError={proposalsError}
        variant="atu2"
      />
      <Atu2NextActionPanel readiness={readiness} market={market} />
      <Atu2ReadinessDetails readiness={readiness} />
      <Atu2CohortPanel readiness={readiness} />
      <Atu2Glossary />
    </div>
  );
}

function PageState({ text, error = false, onRetry }: PageStateProps) {
  return (
    <div className="atu2-lab-page">
      <div className={`atu2-state${error ? ' error' : ''}`}>{text}</div>
      {onRetry && <button className="atu2-refresh" onClick={onRetry}>다시 시도</button>}
    </div>
  );
}

type PageStateProps = { text: string; error?: boolean; onRetry?: () => void };
